import {
    createSelector,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import { apiSlice } from '../../app/api/apiSlice'

const userQuestionResponseWithScoresAdapter = createEntityAdapter({})

const initialState = userQuestionResponseWithScoresAdapter.getInitialState()

export const userQuestionResponseWithScoresApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getUserQuestionResponseWithScores: builder.query({
            query: () => ({
                url: '/userQuestionResponseWithScores',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                }
            }),
            transformResponse: responseData => {
                const loadedUserQuestionResponseWithScores = responseData.map(userQuestionResponseWithScore => {
                    userQuestionResponseWithScore.id = userQuestionResponseWithScore._id
                    return userQuestionResponseWithScore
                })
                return userQuestionResponseWithScoresAdapter.setAll(initialState, loadedUserQuestionResponseWithScores)
            },
            providesTags: (result, error, arg) => {
                if(result?.ids) {
                    return [
                        {type: 'UserQuestionResponseWithScore', id: 'LIST'},
                        ...result.ids.map(id => ({ type: 'UserQuestionResponseWithScore', id}))
                    ]
                } else {
                    return [ { type: 'UserQuestionResponseWithScore', id: 'LIST'}]
                }
            },
        }),
        createNewUserQuestionResponseWithScore: builder.mutation({
            query: initialUserQuestionResponseWithScore => ({
                url: '/userQuestionResponseWithScores',
                method: 'POST',
                body: {...initialUserQuestionResponseWithScore,}
            }),
            invalidatesTags: [
                { type: 'UserQuestionResponseWithScore', id: "LIST" }
            ] 
        }),
        updateUserQuestionResponseWithScore: builder.mutation({
            query: initialUserQuestionResponseWithScore => ({
                url: '/userQuestionResponseWithScores',
                method: 'PATCH',
                body: {...initialUserQuestionResponseWithScore,}
            }),
            invalidatesTags: (result, error, arg) => [
                {type: 'UserQuestionResponseWithScore', id: arg.id },
                { type: 'UserQuestionResponseWithScore', id: 'LIST' }
            ],
        }),
        deleteUserQuestionResponseWithScore: builder.mutation({
            query: ({id}) => ({
                url: '/userQuestionResponseWithScores',
                method: 'DELETE',
                body: {id}
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'UserQuestionResponseWithScore', id: arg.id}
            ]
        }),
    }),
})

export const {
    useGetUserQuestionResponseWithScoresQuery,
    useCreateNewUserQuestionResponseWithScoreMutation,
    useUpdateUserQuestionResponseWithScoreMutation,
    useDeleteUserQuestionResponseWithScoreMutation,
} = userQuestionResponseWithScoresApiSlice

// returns the query result object
export const selectUserQuestionResponseWithScoreResult = userQuestionResponseWithScoresApiSlice.endpoints.getUserQuestionResponseWithScores.select()

// create memoized selector
const selectUserQuestionResponseWithScoresData = createSelector(
    selectUserQuestionResponseWithScoreResult,
    userQuestionResponseWithScoreResult => userQuestionResponseWithScoreResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllUserQuestionResponseWithScores,
    selectById: selectUserQuestionResponseWithScoreById,
    selectIds: selectUserQuestionResponseWithScoreIds,
} = userQuestionResponseWithScoresAdapter.getSelectors(state => selectUserQuestionResponseWithScoresData(state) ?? initialState)